interface Section {
  title: string;
  id: string;
}

type TFunction = (key: string) => string;

// Configuration for Ring Air buy page sections
export const getRingAirSections = (t: TFunction): Record<string, Section> => ({
  'ring-contents': {
    title: t('ring.secondaryHeader.a'),
    id: 'ring-contents',
  },
  'ring-sleep': {
    title: t('ring.secondaryHeader.b'),
    id: 'ring-sleep',
  },
  'ring-reviews': {
    title: t('ring.secondaryHeader.g'),
    id: 'ring-reviews',
  },
  'ring-comparision': {
    title: t('ring.secondaryHeader.c'),
    id: 'ring-comparision',
  },
  'ring-capabilities': {
    title: t('ring.secondaryHeader.d'),
    id: 'ring-capabilities',
  },
  'ring-specs': {
    title: t('ring.secondaryHeader.e'),
    id: 'ring-specs',
  },
  'ring-faq': {
    title: t('ring.secondaryHeader.f'),
    id: 'ring-faq',
  },
});

// Configuration for Rare buy page sections
export const getRareSections = (t: TFunction): Record<string, Section> => ({
  'rare-contents': {
    title: t('ring.secondaryHeader.a'),
    id: 'rare-contents',
  },
  'rare-overview': {
    title: t('ring.secondaryHeader.b'),
    id: 'rare-overview',
  },
  'rare-capabilities': {
    title: t('ring.secondaryHeader.d'),
    id: 'rare-capabilities',
  },
  'rare-specs': {
    title: t('ring.secondaryHeader.e'),
    id: 'rare-specs',
  },
  'rare-faq': {
    title: t('ring.secondaryHeader.f'),
    id: 'rare-faq',
  },
});

// Configuration for Blood Vision sections
export const getBloodVisionSections = (
  t: TFunction,
): Record<string, Section> => ({
  'blood-vision-contents': {
    title: t('bloodVision.secondaryHeader.a'),
    id: 'blood-vision-contents',
  },
  'blood-vision-features': {
    title: t('bloodVision.secondaryHeader.b'),
    id: 'blood-vision-features',
  },
  'blood-vision-specs': {
    title: t('bloodVision.secondaryHeader.c'),
    id: 'blood-vision-specs',
  },
});
